import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { INavigationTileItem } from '@verzekeringapp-mono/shared/src/models/navigation_tile_item'
import LogoSVG from '@verzekeringapp-mono/shared/src/assets/icons/Logo'
import { Link } from 'react-router-dom'

interface IProps {
  tile: INavigationTileItem
}

const NavigationTile: React.FC<IProps> = ({ tile }) => {
  const isInternalLink = !!tile.href && tile.href.startsWith('/') && !tile.openInNewTab

  const content = (
    <>
      <div className='flex h-[50px] w-[50px] items-center justify-center rounded-full bg-surface-brand-subtle text-icon-brand'>
        {tile.icon === 'nh'
          ? (
            <LogoSVG
              width={30}
              height={30}
              className='text-icon-brand'
            />
          )
          : (
            <FontAwesomeIcon
              icon={tile.icon}
              size='lg'
              className='text-icon-brand'
            />
          )}
      </div>

      <p className='text-text-primary'>{tile.title}</p>
    </>
  )

  if (isInternalLink) {
    return (
      <Link
        className='flex min-h-[150px] flex-col items-center justify-center gap-4 rounded-md border border-border-subtle bg-surface-card p-4 text-center text-text-primary'
        to={tile.href}
      >
        {content}
      </Link>
    )
  }

  return (
    <a
      className='flex min-h-[150px] flex-col items-center justify-center gap-4 rounded-md border border-border-subtle bg-surface-card p-4 text-center text-text-primary'
      href={tile.href ? tile.href : undefined}
      target={tile.openInNewTab ? '_blank' : undefined}
      rel='noreferrer'
    >
      {content}
    </a>
  )
}

export default NavigationTile
